import React, {FC} from "react"

import toast, {Toaster, ToastBar, resolveValue} from "react-hot-toast"

import {H5} from "../Typography"
import {CircularCountdown, IconWrapper, ToastBarFlex, CloseIcon} from "./styled"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

const ToastAlert: FC = () => {
  const theme = useTheme()
  const getToasterColor = (type: string, showBackgroundColor: boolean) => {
    switch (type) {
      case "success":
        return showBackgroundColor ? theme.colors.utility.bgSuccess : theme.colors.utility.success
      case "error":
        return showBackgroundColor ? theme.colors.utility.bgError : theme.colors.utility.error
      default:
        return ""
    }
  }

  return (
    <Toaster>
      {(t) => (
        <ToastBar toast={t} style={{background: getToasterColor(t.type, true), width: "100%", maxWidth: "500px"}}>
          {(tb) => {
            return (
              <ToastBarFlex show={t.visible} alignItems="center" justifyContent="space-between">
                <Flex alignItems="center">
                  <IconWrapper color={getToasterColor(t.type, false)} justifyContent="center" alignItems="center">
                    <Icon icon={IconTypes.tick} size={10} color={theme.colors.greys.white} />
                  </IconWrapper>
                  <H5 marginLeft>{resolveValue(tb.message, t)}</H5>
                </Flex>
                <CloseIcon icon={IconTypes.cross} size={16} color={theme.colors.greys.black} onClick={(_e) => toast.dismiss()} />
                <CircularCountdown color={getToasterColor(t.type, false)}>
                  <svg>
                    <circle r="18" cx="20" cy="20"></circle>
                  </svg>
                </CircularCountdown>
              </ToastBarFlex>
            )
          }}
        </ToastBar>
      )}
    </Toaster>
  )
}

export default ToastAlert
